import {LoaderCircleIcon} from 'lucide-react';
import Icon from './Icon.tsx';

// Covers the page while something short finishes.
const OverlayWithSpinner: React.FC = () => {
    return (
        <div className="mx-overlay" role="status">
            <Icon icon={LoaderCircleIcon} size={32} className="mx-spin" />
            <span className="visually-hidden">Working</span>
        </div>
    );
};

export default OverlayWithSpinner;
